import { middlewareConnector } from '@middleware-connector'
import { computed, shallowRef, toValue } from 'vue'
import { useCurrentUser } from './useCurrentUser'
import { useRoles } from './useRoles'

const _allSchoolAuthorities = shallowRef(undefined)

export const useSchoolAuthorities = () => {
    const { uuidCorporations } = useCurrentUser()
    const { hasAdminRole } = useRoles()
    const error = shallowRef(null)
    const errorMessage = computed(() => error.value?.response?.data?.userMessage || error.value?.message)

    //lazy load school authorities
    const allSchoolAuthorities = computed(() => {
        if (!_allSchoolAuthorities.value) {
            initSchoolAuthorities()
        }
        return _allSchoolAuthorities.value || []
    })

    //only the school authorities the user has access to
    const userSchoolAuthorities = computed(() => {
        if (hasAdminRole.value) {
            return allSchoolAuthorities.value
        }
        return allSchoolAuthorities.value?.filter(schoolAuthority => toValue(uuidCorporations).includes(schoolAuthority.uuid)) || []
    })

    const getSchoolAuthorities = async () => {
        error.value = null
        return middlewareConnector.getSchoolAuthorities()
        .catch(err => error.value = err)
    }

    const initSchoolAuthorities = async () => {
        _allSchoolAuthorities.value = await getSchoolAuthorities()
    }

    return {
        errorMessage,
        userSchoolAuthorities,
        allSchoolAuthorities
    }
}

